import get from 'lodash/fp/get';
import keyBy from 'lodash/fp/keyBy';
import merge from 'lodash/fp/merge';

/**
 * Map the values of an object from expected action types to
 * entity state slice reducers.
 * @param   {Object} entityTypeActionTypeMap map of entity types to Redux action types
 * @returns {Object}                         map of entity types to Redux reducers
 */
export default function combineEntityReducers(entityTypeActionTypeMap) {
  const assignReducer = (combinedReducers, stateKey) => {
    const actionType = entityTypeActionTypeMap[stateKey];
    return {
      ...combinedReducers,
      [stateKey]: createEntityReducer(actionType, stateKey),
    };
  };

  return Object
    .keys(entityTypeActionTypeMap)
    .reduce(assignReducer, {});
}

/**
 * Create a state slice reducer that indexes and merges entities from
 * an expected Redux action type.
 * @param   {string}   actionType Redux action type
 * @param   {string}   entityType entity type the reducer acts on
 * @returns {function}            Redux reducer
 */
export function createEntityReducer(actionType, entityType) {
  return (state = {}, { type, payload }) => {
    const entities = get(entityType, payload);
    if (type !== actionType || !entities) {
      return state;
    }

    if (entities.length && entities[0].id) {
      return merge(state, keyBy('id', entities));
    }

    return merge(state, entities);
  };
}
